import apiPath from "../config/api-path";
import httpRequest from "../config/http-api";

export default {
  getTrainingList(config, { success, error }) {
    const {
      training: { list },
    } = apiPath;
    return httpRequest.getRequest(list, success, error, config);
  },
  getTrainingListOptions(config, { success, error }) {
    const {
      training: { listOptions },
    } = apiPath;
    return httpRequest.getRequest(listOptions, success, error, config);
  },
  createTraining(payload, { success, error }) {
    const {
      training: { create },
    } = apiPath;
    return httpRequest.postRequest(create, payload, success, error);
  },
  getTrainingById(id, { success, error }) {
    const {
      training: { getById },
    } = apiPath;
    return httpRequest.getRequest(getById(id), success, error);
  },
  getTrainingListByPagination(config, { success, error }) {
    const {
      training: { listByPagination },
    } = apiPath;
    return httpRequest.getRequest(listByPagination, success, error, config);
  },
  getTrainingListOnlyTraining(config, { success, error }) {
    const {
      training: { listOnlyTraining },
    } = apiPath;
    return httpRequest.getRequest(listOnlyTraining, success, error, config);
  },
  getUsersForEnrolledTraining(id, config, { success, error }) {
    const {
      workSheet: { usersForEnrolledTraining },
    } = apiPath;
    return httpRequest.getRequest(usersForEnrolledTraining(id), success, error, config);
  },
  getCreatedTrainingList(id, config, { success, error }) {
    const {
      training: { createdList },
    } = apiPath;
    return httpRequest.getRequest(createdList(id), success, error, config);
  },
  enrollTraining(payload, { success, error }) {
    const {
      workSheet: { enroll },
    } = apiPath;
    return httpRequest.postRequest(enroll, payload, success, error);
  },
  bulkAssignTraining(payload, { success, error }) {
    const {
      workSheet: { bulkAssign },
    } = apiPath;
    return httpRequest.postRequest(bulkAssign, payload, success, error);
  },
  getWorksheetsByUserId(id, { success, error }) {
    const {
      workSheet: { getById },
    } = apiPath;
    return httpRequest.getRequest(getById(id), success, error);
  },
  createTemplate(payload, { success, error }) {
    const {
      template: { create },
    } = apiPath;
    return httpRequest.postRequest(create, payload, success, error);
  },
  getAllTemplate(config,{ success, error }){
    const {
      template: { getTemplate },
    } = apiPath;
    return httpRequest.getRequest(getTemplate, success, error,config);
  },
  setTemplateData(adminId,payload,{success,error}){
    const {
      template: { setData },
    } = apiPath;
    return httpRequest.postRequest(setData(adminId), payload, success, error);
  },
  getEvaluationScore(adminId,config,{success,error}){
    const {
      template: { evaluationReport },
    } = apiPath;
    return httpRequest.getRequest(evaluationReport(adminId), success, error,config);
  }
};
